const initialState = {
  // Getting ATL List
  isGettingAtlList: false,
  atlList: [],
  page: 0,
  totalResults: 0,
  // False when totalResults is only "at least this many" (name searches).
  totalIsExact: true,
  hasMore: false,
  // browse | id | name | tooShort
  mode: "browse",
  // Hint or problem to show above the table, e.g. "Type at least 3 characters".
  listMessage: "",
  listError: "",

  // What is live right now: { totalRows, fileName, importedAt } or null
  dataset: null,
  // True once a search has answered - `dataset` is then known even for a
  // user who cannot ask for the import status (administrators only).
  hasLoadedAtlList: false,

  // Getting ATL Import Status
  isGettingAtlStatus: false,
  hasLoadedAtlStatus: false,
  // The upload/import that is running, or null
  activeImport: null,
  // The most recent one that has finished (completed / failed / cancelled)
  lastImport: null,

  // Getting ATL Import History
  isGettingAtlHistory: false,
  atlHistory: [],

  // Cancelling an upload
  isCancellingAtlUpload: false,

  // Uploading the ATL file from this browser
  // idle | uploading | uploaded | error | cancelled
  uploadStatus: "idle",
  uploadFileName: "",
  uploadLoaded: 0,
  uploadTotal: 0,
  // True when the server already had part of this file and it carried on.
  uploadResumed: false,
  uploadError: "",
  // Id of the import the finished upload started, to recognise its result.
  uploadImportId: "",
};

const AtlReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting ATL List
    case "ATL_LIST_REQUEST":
      return {
        ...state,
        isGettingAtlList: true,
        listError: "",
      };
    case "ATL_LIST_SUCCESS":
      return {
        ...state,
        atlList: action.payload?.data || [],
        page: action.payload?.page || 0,
        totalResults: action.payload?.totalResults || 0,
        totalIsExact: action.payload?.totalIsExact !== false,
        hasMore: Boolean(action.payload?.hasMore),
        mode: action.payload?.mode || "browse",
        listMessage: action.payload?.message || "",
        dataset: action.payload?.dataset || null,
        hasLoadedAtlList: true,
        isGettingAtlList: false,
      };
    case "ATL_LIST_ERROR":
      return {
        ...state,
        atlList: [],
        totalResults: 0,
        totalIsExact: true,
        hasMore: false,
        listError: action.payload || "",
        isGettingAtlList: false,
      };
    // Getting ATL Import Status
    case "ATL_STATUS_REQUEST":
      return {
        ...state,
        isGettingAtlStatus: true,
      };
    case "ATL_STATUS_SUCCESS":
      return {
        ...state,
        activeImport: action.payload?.active || null,
        lastImport: action.payload?.last || null,
        dataset: action.payload?.dataset || null,
        isGettingAtlStatus: false,
        hasLoadedAtlStatus: true,
      };
    case "ATL_STATUS_ERROR":
      return {
        ...state,
        isGettingAtlStatus: false,
      };
    // Getting ATL Import History
    case "ATL_HISTORY_REQUEST":
      return {
        ...state,
        isGettingAtlHistory: true,
      };
    case "ATL_HISTORY_SUCCESS":
      return {
        ...state,
        atlHistory: action.payload?.data || [],
        isGettingAtlHistory: false,
      };
    case "ATL_HISTORY_ERROR":
      return {
        ...state,
        isGettingAtlHistory: false,
      };
    // Cancelling an upload
    case "CANCEL_ATL_UPLOAD_REQUEST":
      return {
        ...state,
        isCancellingAtlUpload: true,
      };
    case "CANCEL_ATL_UPLOAD_SUCCESS":
      return {
        ...state,
        isCancellingAtlUpload: false,
      };
    case "CANCEL_ATL_UPLOAD_ERROR":
      return {
        ...state,
        isCancellingAtlUpload: false,
      };
    // Uploading the ATL file
    case "UPLOAD_ATL_FILE_REQUEST":
      return {
        ...state,
        uploadStatus: "uploading",
        uploadFileName: action.payload?.fileName || "",
        uploadLoaded: 0,
        uploadTotal: action.payload?.total || 0,
        uploadResumed: false,
        uploadError: "",
        uploadImportId: "",
      };
    case "UPLOAD_ATL_FILE_PROGRESS":
      return {
        ...state,
        uploadLoaded: action.payload?.loaded || 0,
        uploadTotal: action.payload?.total || state.uploadTotal,
        uploadResumed: state.uploadResumed || Boolean(action.payload?.resumed),
      };
    case "UPLOAD_ATL_FILE_SUCCESS":
      return {
        ...state,
        uploadStatus: "uploaded",
        uploadLoaded: state.uploadTotal,
        uploadImportId: action.payload?.importId || "",
      };
    case "UPLOAD_ATL_FILE_ERROR":
      return {
        ...state,
        uploadStatus: "error",
        uploadError: action.payload || "The upload failed.",
      };
    case "UPLOAD_ATL_FILE_CANCELLED":
      return {
        ...state,
        uploadStatus: "cancelled",
      };
    case "UPLOAD_ATL_FILE_CLEAR":
      return {
        ...state,
        uploadStatus: state.uploadStatus === "uploading" ? "uploading" : "idle",
        uploadError: "",
      };
    default:
      return state;
  }
};

export default AtlReducer;
